/**
 * Legacy: Social (Blog Sharing Buttons)
 *
 * Used by: template-parts/single/social-share-buttons.php
 *
 * @module legacy/LSocial
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	$(document).ready(function() {
		$('.share-btn').click(function(e) {
			e.preventDefault();
			window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
			return false;
		});
	});

	$('.on24-social-icon button.svg-container').focusin(function(e) {
		$('.on24-share-button').css('display', 'none');
		$(this).parent().find('.on24-share-button').css('display', 'block');
	})

	$('.on24-share-button .share-btn').focusout(function(e) {
		$('.on24-share-button').css('display', 'none');
	})

	$('.on24-social-icon').mouseover(function(e) {
		$('.on24-share-button').css('display', 'none');
		$(this).find('.on24-share-button').css('display', 'block');
	}).mouseleave(function(e) {
		if (!$(e.relatedTarget).hasClass('on24-social-icon')) {
			$('.on24-share-button').css('display', 'none');
		}
	});

}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
